
import React,{useRef,useState,useEffect,memo,useCallback} from 'react'
import {useParams} from 'react-router-dom'
import Page from './Page'
import {fetchCMSJSON} from 'system/AssetManager'
import axios from 'axios'
import Globals from 'system/Globals'


const PageRender = function(props){

    let { id,pageid } = useParams();
    
    let [pageModel,setPageModel] = useState(null)

    const [loading , setLoading ]= useState(true)
    // Distinct from `loading`. `loading` only tracks the page JSON fetch, so the existing
    // `loaded` class goes on as soon as the model arrives -- long before any image, video
    // or module has painted. That gap is what sleep(7) has been papering over in
    // GenerateSectionPDF. `render-ready` is the real signal and is purely ADDITIVE: the
    // `loaded` class is untouched, so nothing currently relying on it changes behaviour.
    const [renderReady, setRenderReady] = useState(false)
    const [tempUser, setTempUser] = useState(true);

    const [forceFormat, setForceFormat] = useState(null);

    useEffect(()=>{

        if (props && props.location.search) {
            let narrativeToken;

            let params = new URLSearchParams(props.location.search)
            narrativeToken = params.get('u');

            let fw = params.get('w');
            let fh = params.get('h');
            if (fw && fh) {
                setForceFormat({ canvas_width: fw + 'px', canvas_height: fh + 'px', aspect_ratio: (parseFloat(fw)/parseFloat(fh)).toFixed(3) });
            }
            
            console.log(narrativeToken)
            
            if (narrativeToken) {
             
                axios({
                    method: 'post',
                    baseURL: Globals.instance().adminOriginAPI,
                    url: 'api/core/verify-narrative-token/',
                    data: {
                        "link_token": narrativeToken,
                        "narrative_id": id
                    }
                    })
                    .then(response => {  

                        let userObj = {}
                        userObj.narratives = [parseInt(id)]
                        userObj.market= null
                        userObj.category= "anon"
                        userObj.device_sn = null
                        userObj.link_token = narrativeToken
                        userObj.token = narrativeToken
                        console.log('userObj', userObj)
                        // props.setUser(userObj)
                        setTempUser(userObj)

                    }).catch(function (error) {
                        console.error(error.response)    
                        
                    })
    
            } 
        } 
       
        console.log('Globals', Globals)

    },[props])

    useEffect(() => {
        if (tempUser) {
            const loadPage = async (url)=>{
                try{
                    let pm = await fetchCMSJSON(url,null,null,tempUser.token)
                    setPageModel(pm)
                    setLoading(false)
                }catch( e ){
                
                    console.error(e)
             
                }
            }
            console.log('narrative', id)
           loadPage('narrative/'+id+'/'+pageid+'/?format=json')
        }
    }, [tempUser])

    function setScrollTable(){

    }
    // Page calls this once every component on the page has reported itself loaded
    // (Page.js onLoadComplete). It used to be an empty function, so the one signal that
    // actually means "this page has finished" was thrown away -- which is why the PDF
    // renderer screenshots on a fixed sleep(7) instead of waiting for anything real.
    function onPageLoad(){
        setRenderReady(true)
    }
    function Interaction(){}
    function onIntersect(){}

    return (<div className={`fullscreen pagerender ${loading?'loading':'loaded'}${renderReady?' render-ready':''}`}>

          { pageModel && (
          <Page key={`${id}-${pageid}` }
            id={`${id}-${pageid}` }
            model={pageModel}
            onLoad={onPageLoad}
            interaction={Interaction}
            pageIndex={0}
            theme={{}}
            onIntersect={onIntersect}
            setScrollCallback={setScrollTable}
            renderOnly={true}
            nid={id}
            index={0}
            flatMenuItems={[]}
            PageModels={[]}
            activePage={pageid}

            ></Page>)
        }


        </div>)
    
}

export default PageRender;
